import { makeStyles } from "@material-ui/core/styles";
import TreeItem from "@material-ui/lab/TreeItem";
import useHierarchy from "backend/hooks/elements/useHierarchy";
import Todo from "design/components/misc/Todo";
import * as m from "qpr-base/api/model";
import useParents from "qpr-base/apihooks/useParents";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import React from "react";
import { useQuery } from "react-query";
import { getChildElements } from "../../backend/model/getChildElements";
import { getValueSettings } from "../../backend/model/getValueSettings";
import { ICardElement } from "../../backend/model/model";
const useStyles = makeStyles({
  root: {
    height: 110,
    flexGrow: 1,
    maxWidth: 400,
  },
});

const ShowCard = (props: {
  card: ICardElement;
  onSelect?: (card: ICardElement) => void;
}) => {
  const { isLoading, data } = useQuery(`scorecards${props.card.id}`, () =>
    getChildElements(props.card.id)
  );
  if (isLoading) return null;
  const { card } = props;
  return (
    <TreeItem
      key={card.id}
      nodeId={card.id}
      label={card.name || card.id}
      onClick={() => {
        if (props.onSelect) props.onSelect(card);
      }}
    >
      {data?.map((item) => {
        return <ShowCard card={item} onSelect={props.onSelect} />;
      })}
    </TreeItem>
  );
};

const ValueSettings = (props: { elementId: string; periodlevel: string }) => {
  const ctx = useAppContext();

  const { data: periods } = useQuery(`periods-${ctx.modelId}`, async () => {
    return m.getPeriods(ctx.fullModelId || "");
  });
  const { isLoading, data } = useQuery(`valuesetting-${props.elementId}`, () =>
    getValueSettings(props.elementId)
  );
  if (isLoading) return null;
  return (
    <div>
      <table>
        {data?.map((s) => {
          return (
            <tr key={s.id}>
              <td>{s.name}</td>
              <td>{s.id}</td>
              <td>{s.symbol}</td>
              <td>{s.description}</td>
            </tr>
          );
        })}
      </table>

      <table>
        {periods
          ?.filter((v) => v.periodlevel === props.periodlevel)
          ?.sort((a, b) => a.startdate.localeCompare(a.enddate))
          ?.map((s) => {
            return (
              <tr key={s.id}>
                <td>{s.name}</td>
                <td>{s.id}</td>
                <td>{s.startdate}</td>
                <td>{s.enddate}</td>
              </tr>
            );
          })}
      </table>
    </div>
  );
};

export default function ShowElementData(props: {
  card: ICardElement;
  onSelect?: (card: ICardElement) => void;
}) {
  const { data } = useHierarchy(props.card.id);
  const parents = useParents(props.card.id);
  const classes = useStyles();
  const { card } = props;
  return (
    <div>
      <Todo>Hello</Todo>
      <table>
        <tr>
          <td>ID</td>
          <td>{card.id}</td>
        </tr>
        <tr>
          <td>Symbol</td>
          <td>{card.symbol}</td>
        </tr>
        <tr>
          <td>Type</td>
          <td>{card.typename}</td>
        </tr>
        <tr>
          <td>Description</td>
          <td style={{ maxWidth: "200px" }}>{card.description}</td>
        </tr>
        <tr>
          <td>Periodlevel</td>
          <td style={{ maxWidth: "200px" }}>{card.periodlevel}</td>
        </tr>
      </table>
      <ValueSettings elementId={props.card.id} periodlevel={card.periodlevel} />

      <h2>Parents</h2>
      <pre>{JSON.stringify(parents, null, 2)}</pre>
      <h2>Children</h2>
      <pre>{JSON.stringify(data, null, 2)}</pre>
    </div>
  );
}
